import * as z from "zod/v4";

const verificationItemPhotoSchema = z.object({
  url: z.string(),
  note: z.string().optional(),
});

const verificationItemSchema = z.object({
  returnItemId: z.string().nullable(),
  inventoryItemId: z.string().nullable(),
  kind: z.enum(["declared", "undeclared", "unknown"]),
  result: z.enum([
    "pending",
    "item_like_new",
    "item_damaged",
    "item_not_received",
  ]),
  photos: z.array(verificationItemPhotoSchema).nullable(),
  notes: z.string().nullable(),
});

const verificationRecordSchema = z.object({
  lifecycleStage: z.enum(["return_point", "warehouse"]),
  result: z.enum(["pending", "pass", "fail"]),
  performedAt: z.string(),
  items: z.array(verificationItemSchema),
});

export const getReturnVerification = {
  name: "getReturnVerification" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({ verification: verificationRecordSchema.nullable() }),
};

export type VerificationItem = z.infer<typeof verificationItemSchema>;
export type VerificationRecord = z.infer<typeof verificationRecordSchema>;
